import { render } from "./App.vue?vue&type=template&id=1590e42e"
const script = {}

import exportComponent from "C:\\wamp64\\www\\work\\vuejs\\geolocation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__